import { createSlice } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
};

const exportTimeKeepingManagerSlice = createSlice({
  name: "exportTimeKeepingManager",
  initialState,
  reducers: {
    exportTimeKeepingManagerStart: (state) => {
      state.status = ReduxStateType.LOADING;
    },
    exportTimeKeepingManagerSuccess: (state) => {
      state.status = ReduxStateType.SUCCESS;
    },
    exportTimeKeepingManagerFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
  },
});

export const {
  exportTimeKeepingManagerStart,
  exportTimeKeepingManagerSuccess,
  exportTimeKeepingManagerFailed,
} = exportTimeKeepingManagerSlice.actions;

export default exportTimeKeepingManagerSlice.reducer;
